import styled from 'styled-components';
export const Wrapper = styled.li `
  border: 0.1rem solid var(--border);
  border-radius: var(--border-radius-sm);
`;
export const Header = styled.span `
  font: var(--heading-five-font);
  color: var(--primary-darker);
`;
export const Text = styled.span `
  color: var(--text);
  font: var(--paragraph-font);
`;
export const Date = styled(Text) `
  display: block;
  margin-bottom: 1.5rem;
`;
export default {
    Wrapper,
    Header,
    Text,
    Date,
};
